import { CarePrincipalDTO, CarePrincipalSettings } from "../../generated/api";

export const GET_CAREPRINCIPAL_SETTINGS = "GET_CAREPRINCIPAL_SETTINGS";
export const SET_CAREPRINCIPAL_SETTINGS = "SET_CAREPRINCIPAL_SETTINGS";

export const GET_ALL_CAREPRINCIPALS = "GET_ALL_CAREPRINCIPALS";
export const SAVE_CAREPRINCIPAL = "SAVE_CAREPRINCIPAL";
export const ADD_CAREPRINCIPAL = "ADD_CAREPRINCIPAL";
export const DELETE_CAREPRINCIPAL = "DELETE_CAREPRINCIPAL";
export const SET_ALL_CAREPRINCIPALS = "SET_ALL_CAREPRINCIPALS";

export const SET_CONNECTED_CAREPRINCIPALS = "SET_CONNECTED_CAREPRINCIPALS";
export const GET_CONNECTED_CAREPRINCIPALS = "GET_CONNECTED_CAREPRINCIPALS";
export const DELETE_CARE_PRINCIPAL_ACCESS_MODAL =
  "DELETE_CARE_PRINCIPAL_ACCESS_MODAL";
export const UPDATE_CARE_PRINCIPAL_ACCESS_MODAL =
  "UPDATE_CARE_PRINCIPAL_ACCESS_MODAL";
export const DELETE_CARE_PRINCIPAL_ACCESS = "DELETE_CARE_PRINCIPAL_ACCESS";
export const GET_CARE_PRINCIPAL_ACCESS = "GET_CARE_PRINCIPAL_ACCESS";
export const SET_CARE_PRINCIPAL_ACCESS = "SET_CARE_PRINCIPAL_ACCESS";
export const ADD_CARE_PRINCIPAL_ACCESS = "ADD_CARE_PRINCIPAL_ACCESS";
export const SET_SELECTED_CARE_PRINCIPAL_ACCESS =
  "SET_SELECTED_CARE_PRINCIPAL_ACCESS";
export const UPDATE_CARE_PRINCIPAL_ACCESS = "UPDATE_CARE_PRINCIPAL_ACCESS";
// COMFACT - KOMMER ATT TAS BORT 
// export const GET_ALLOWED_CONTRACTS = "GET_ALLOWED_CONTRACTS";
// export const SET_ALLOWED_CONTRACTS = "SET_ALLOWED_CONTRACTS";
// export const UPDATE_ALLOWED_CONTRACTS = "UPDATE_ALLOWED_CONTRACTS";
export const GET_JOBS_CONFIGURATIONS = "GET_JOBS_CONFIGURATIONS";
export const SET_JOBS_CONFIGURATIONS = "SET_JOBS_CONFIGURATIONS";
export const UPDATE_JOBS_CONFIGURATIONS = "UPDATE_JOBS_CONFIGURATIONS";
export const GET_PU_NAMES = "GET_PU_NAMES";
export const SET_PU_NAMES = "SET_PU_NAMES";
export const UPDATE_CARE_PRINCIPAL_SETTINGS = "UPDATE_CARE_PRINCIPAL_SETTINGS";
export const SAVE_SETTINGS_FILE = "SAVE_SETTINGS_FILE";
export const GET_SETTINGS_FILE_NAMES = "GET_SETTINGS_FILE_NAMES";
export const SET_SETTINGS_FILE_NAMES = "SET_SETTINGS_FILE_NAMES";
// COMFACT - KOMMER ATT TAS BORT 
// export const SET_SELECTED_CONTRACT = "SET_SELECTED_CONTRACT";
export const GET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER =
  "GET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER";
export const SET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER =
  "SET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER";
export const RESET_CARE_PRINCIPAL = "RESET_CARE_PRINCIPAL";
export const GET_CARE_UNIT_SETTINGS = "GET_CARE_UNIT_SETTINGS";
export const SET_CARE_UNIT_SETTINGS = "SET_CARE_UNIT_SETTINGS";
export const SAVE_CARE_UNIT_SETTINGS = "SAVE_CARE_UNIT_SETTINGS";
export const DELETE_CARE_UNIT_SETTINGS = "DELETE_CARE_UNIT_SETTINGS";
export const SET_CURRENT_CARE_PRINCIPAL_SETTINGS =
  "SET_CURRENT_CARE_PRINCIPAL_SETTINGS";
export const GET_CURRENT_CARE_PRINCIPAL_SETTINGS =
  "GET_CURRENT_CARE_PRINCIPAL_SETTINGS";

export const deleteCarePrincipalAccessModal = (item: any) => ({
  type: DELETE_CARE_PRINCIPAL_ACCESS_MODAL,
  item,
});

export const updateCarePrincipalAccessModal = (item: any) => ({
  type: UPDATE_CARE_PRINCIPAL_ACCESS_MODAL,
  item,
});

export const deleteCarePrincipalAccess = (item: any) => ({
  type: DELETE_CARE_PRINCIPAL_ACCESS,
  item,
});

export const updateCarePrincipalAccess = (item: any) => ({
  type: UPDATE_CARE_PRINCIPAL_ACCESS,
  item,
});

// COMFACT - KOMMER ATT TAS BORT 
// export const setAllowedContracts = (contracts: any) => ({
//   type: SET_ALLOWED_CONTRACTS,
//   contracts,
// });
export const setPuNames = (puNames: any) => ({
  type: SET_PU_NAMES,
  puNames,
});

export const setCareUnitSettings = (careUnitSettings: any) => ({
  type: SET_CARE_UNIT_SETTINGS,
  careUnitSettings,
});

export const setSettingsFileNames = (fileNames: any) => ({
  type: SET_SETTINGS_FILE_NAMES,
  fileNames,
});

export const setCarePrincipalIds = (carePrincipals: any) => ({
  type: SET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER,
  carePrincipals,
});

export const setCarePrincipalAccess = (carePrincipal: any) => ({
  type: SET_CARE_PRINCIPAL_ACCESS,
  carePrincipal,
});

export const setSelectedCarePrincipalAccess = (item: any) => ({
  type: SET_SELECTED_CARE_PRINCIPAL_ACCESS,
  item,
});

export const setJobsConfigurations = (jobs: any) => ({
  type: SET_JOBS_CONFIGURATIONS,
  jobs,
});

export const setAllCarePrincipals = (
  allCarePrincipals: CarePrincipalDTO[]
) => ({
  type: SET_ALL_CAREPRINCIPALS,
  allCarePrincipals,
});

export const setConnectedCarePrincipals = (
  connectedCarePrincipals: CarePrincipalDTO[]
) => ({
  type: SET_CONNECTED_CAREPRINCIPALS,
  connectedCarePrincipals,
});

export const setCarePrincipalsSettings = (
  carePrincipalSettings: CarePrincipalSettings
) => ({
  type: SET_CAREPRINCIPAL_SETTINGS,
  carePrincipalSettings,
});

const initialState = {
  carePrincipal: null,
};

export const administrationReducer = (state = initialState, action: any) => {
  const { item } = action;
  const { carePrincipal } = action;
  // COMFACT - KOMMER ATT TAS BORT 
  // const { contracts } = action;
  const { jobs } = action;
  const { puNames } = action;
  const { fileNames } = action;
  const { carePrincipalSettings } = action;
  const { connectedCarePrincipals } = action;
  // COMFACT - KOMMER ATT TAS BORT 
  // const { contract } = action;
  const { carePrincipals } = action;
  const { currentCarePrincipalSettings } = action;
  const { careUnitSettings } = action;
  const { allCarePrincipals } = action;

  switch (action.type) {
    case SET_SELECTED_CARE_PRINCIPAL_ACCESS:
      return { ...state, item };
    case SET_CURRENT_CARE_PRINCIPAL_SETTINGS:
      return { ...state, currentCarePrincipalSettings };
    case DELETE_CARE_PRINCIPAL_ACCESS_MODAL:
      return { ...state, item };
    case UPDATE_CARE_PRINCIPAL_ACCESS_MODAL:
      return { ...state, item };
    case SET_CARE_PRINCIPAL_ACCESS:
      return { ...state, carePrincipal };
    // COMFACT - KOMMER ATT TAS BORT 
    // case SET_ALLOWED_CONTRACTS:
    //   return { ...state, contracts };
    case SET_JOBS_CONFIGURATIONS:
      return { ...state, jobs };
    case SET_PU_NAMES:
      return { ...state, puNames };
    case SET_SETTINGS_FILE_NAMES:
      return { ...state, fileNames };
    // COMFACT - KOMMER ATT TAS BORT 
    // case SET_SELECTED_CONTRACT:
    //   return { ...state, contract };
    case SET_CARE_PRINCIPAL_ID_FROM_CURRENT_USER:
      return { ...state, carePrincipals };
    case SET_ALL_CAREPRINCIPALS:
      return { ...state, allCarePrincipals };
    case SET_CARE_UNIT_SETTINGS:
      return { ...state, careUnitSettings };
    case SET_CONNECTED_CAREPRINCIPALS:
      return { ...state, connectedCarePrincipals };
    case SET_CAREPRINCIPAL_SETTINGS:
      return { ...state, carePrincipalSettings };
    case RESET_CARE_PRINCIPAL:
      return initialState;
    default:
      return state;
  }
};
